import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  body, html, body * {
    font-family: 'Poppins', sans-serif;
    font-weight: normal;
  }
`

export default GlobalStyles
